<!--  -->
<template>
  <div>
       <div class="shadow mb-5 bg-light rounded login-top">
          <div class="head">
              <img src="/static/images/ZGY_hx_h_n.png"><span><h1>·</h1>登录</span>
          </div>
      </div>
      <div class="login-box">
          <img src="/static/images/bmrecode.png" style="    float: left;
      position: absolute;
      width: 207px;"/>
          <div class="tree">
              <img src="/static/images/er.png" class="img-fluid">
          </div>
          <div class="slogan">
              自强不息<br><span class="yellow">厚德载物</span>
          </div>
          <div id="earth" class="earth">
              <img src="/static/images/yi.png" class="img-fluid">
          </div>
          <!-- 登录 -->
          <div class="login">
              <div class="login-logo">
                  <img src="/static/images/ZGY_sx_n.png" class="img-fluid">
              </div>
              <div class="login-form">
                  <div>
                      <div class="input-group mb-3">
                          <el-input placeholder="请输入证件号码" v-model="loginUser.identificationcard" >
                             <template slot="prepend">
                                  <i class="fa el-icon-user-solid text-success"></i></template>
                           </el-input>
                      </div>
                      <div class="input-group mb-3">
                           <el-input placeholder="请输入密码" v-model="loginUser.password" show-password>
                             <template slot="prepend">
                                  <span class="fa fa-unlock text-success"></span></template>
                           </el-input>
                      </div>
                      <!-- <div class="input-group mb-3">
                           <el-input placeholder="请输入验证码" v-model="loginUser.yzcode">
                             <template slot="prepend">
                                  <i class="fa el-icon-info text-success"></i></template>
                           </el-input>
                            <img
                  :src="loginUser.yzmsrc"
                  @click="getImgVerify()"
                  style="width: 31%"
                  alt="看不清?请点击刷新"
                  title="看不清?请点击刷新"
                  class="validate-code"
                  />
                      </div> -->
                      <button type="button" id="login" class="btn btn-success btn-block"  @click="submitForm()" >登录</button>
                     <router-link to="/signup" class="signup">线上报名<i class="el-icon-arrow-right"></i></router-link><br/>
                  </div>
              </div>
              <div class="login-regist">
                   <input type="checkbox"  id="brand1" v-model="checked" >
                      <label for="brand1"><span></span>记住我的登录信息</label>
                       
              </div>
               
          </div>
      </div>
  
      <div class="box-bg">
          <div class="box">
              <img src="/static/images/cw.png" class="cuo">
              <span class="top-s">身份验证</span>
              <span class="top-x">拖动滑块，使图片角度为正</span>
              <div id="rotateWrap1">
                  <div class="rotateverify-contaniner">
                      <div class="rotate-can-wrap">
                          <canvas class="rotateCan rotate-can" width="200" height="200"></canvas>
                          <div class="statusBg status-bg"></div>
                      </div>
                      <div class="control-wrap slideDragWrap">
                          <div class="control-tips">
                              <p class="c-tips-txt cTipsTxt">滑动将图片转正</p>
                          </div>
                          <div class="control-bor-wrap controlBorWrap"></div>
                          <div class="control-btn slideDragBtn">
                              <i class="control-btn-ico"></i>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <center>
      <div style="font-size: 10px;background-color:#c3c3c3"><a href="http://beian.miit.gov.cn/" style="color:#000" target="_blank">京ICP备2022002443号-1</a></div>
      </center>
   </div>
  
  </template>
  <script>
  import jwt_decode from "jwt-decode";
  import global from "../components/PublicComs/Common.vue";
  import { Message } from "element-ui";
  export default {
    data() {
      return {
        loginUser: {
          password: "",
          identificationcard: "",
          yzcode: "",
          yzmsrc: "",
        },
        global,
        webConfig: {},
        checked: false,
      };
    },
  
    components: {},
  
    computed: {},
  
    mounted() {
      this.$axios.get("/api/webConfigs").then((res) => {
        if (res.data && res.data.data.length > 0) {
          this.webConfig = res.data.data[0];
        }
      });
      this.getImgVerify();
      this.getCookie();
      window.addEventListener("keydown", this.keyDown);
       setTimeout(()=>{
         this.changeState();
       }, 1000)
          //地球动画
      $(".cuo").click(function () {
          $(".box-bg").css("display", "none");
          $("#login").attr("disabled", false);
      })   
      this.global.loadScript('/static/js/yz.js',() => {
        console.log("加载成功");
      });
    },
    beforeCreate() {
      document
        .querySelector("body")
        .setAttribute(
          "style",
          ''
        );
    },
    beforeDestroy() {
      document.body.removeAttribute("style");
      window.removeEventListener("keydown", this.keyDown, false);
    },
    created() {},
    methods: {
      changeState() {
            // console.log('动画开始');
            $('#earth').removeClass('earth');
            $('#earth').addClass('move');
        },
      submitForm() {
        if (!this.loginUser.password) {
          Message.error("密码不能为空！");
          return;
        } else if (!this.loginUser.identificationcard) {
          Message.error("身份证号码不能为空！");
          return;
        }
         $(".box-bg").css("display", "block");
        var myRotateVerify = new RotateVerify('#rotateWrap1', {
            initText: '滑动将图片转正', //默认
            slideImage: [
                '/static/images/33.png',
                '/static/images/4.png',
                '/static/images/5.png'
            ], //arr  [imgsrc1,imgsrc2] 或者str 'imgsrc1'
            slideAreaNum: 10, // 误差范围角度 +- 10(默认)
            getSuccessState:  (res)=> { //验证通过 返回  true;
                if (res) {//验证通过
                    setTimeout(function () {
                        $(".box-bg").css("display", "none");
                    }, 1000);
                    //处理业务逻辑
                     this.$axios.post("/api/auth/login", this.loginUser).then((res) => {
                    // 登录成功
                    const self = this;
                    //判断复选框是否被勾选 勾选则调用配置cookie方法
                    if (self.checked == true) {
                      console.log("checked == true");
                      //传入账号名，密码，和保存天数3个参数
                      self.setCookie(
                        this.loginUser.password,
                        this.loginUser.identificationcard,
                        30
                      );
                    } else {
                      console.log("清空Cookie");
                      //清空Cookie
                      self.clearCookie();
                      self.setCookie(this.loginUser.password, "", 30);
                    }
                    const { token } = res.data;
                    localStorage.setItem("eleTokenCustCysd001", token);
  
                    // 解析token
                    const decode = jwt_decode(token);
                    // 存储数据
                    this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
                    this.$store.dispatch("setUser", decode);
                    //获取购买的课程
                     let arrhasCourse = [];
                      for (var i = 0; i <res.data.data.needexaminee.length; i++)
                      {
                        arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
                      }
                      this.$root.hasCourse =arrhasCourse;
                    this.$root.ischeckface = res.data.data.ischeckface;
                    this.$root.onlymycourse = res.data.data.onlymycourse;
                    this.$root.buytype = res.data.data.buytype;
                    if( res.data.data.onlymycourse)
                       localStorage.setItem("onlymycourseCySd", "1");
                    else
                      localStorage.setItem("onlymycourseCySd", "0");
                    localStorage.setItem("hasCourseCySd", arrhasCourse.join(","));
                    // 页面跳转
                    this.$router.push("/");
                  });
                } else {//验证不通过
                }
            }
        })
  
  
       
      },
      getImgVerify() {
        this.loginUser.yzmsrc =
          `${this.global.remoteIp}/api/auth/imgverify` + "?" + Math.random();
      },
      keyDown(e) {
        //如果是按回车则执行登录方法
        if (e.keyCode == 13) {
          this.submitForm();
        }
      },
      //设置cookie
      setCookie(c_name, c_id, exdays) {
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        //字符串拼接cookie
        window.document.cookie =
          "stuName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        if (c_id) {
          window.document.cookie =
            "stuId" + "=" + c_id + ";path=/;expires=" + exdate.toGMTString();
        }
      },
      //读取cookie
      getCookie: function() {
        if (document.cookie.length > 0) {
          var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("="); //再次切割
            //判断查找相对应的值
            if (arr2[0] == "stuName") {
              this.loginUser.password = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == "stuId") {
              this.loginUser.identificationcard = arr2[1];
              this.checked = true;
            }
          }
        }
      },
      isEmpty(value) {
        return (
          value === undefined ||
          value === null ||
          (typeof value === "object" && Object.keys(value).length === 0) ||
          (typeof value === "string" && value.trim().length === 0)
        );
      },
      //清除cookie
      clearCookie: function() {
        this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "@/assets/css/popuo-box.scss";
  @import "@/assets/css/loginstyle.scss";
  .validate-code {
    position: initial;
    /* top: 2px; */
    right: 0%;
    //width: 36%;
    height: 44px;
    vertical-align: middle;
  }
  .text-success{
        color: #6510ad!important;
  }
  .head{
      width: 623px;
  }
  .head img{
    width: 226px;
      height: 80px;
  }
  .login-logo img{
        height: 167px;
  }
  .login-logo{
    width: 235px;
    height: 140px;
  }
  .login-form{
        padding-top: 10px;
  }
  .head img{
    margin-top:0px;
  }
  .signup{
    float: right;
      text-decoration: underline;
      font-size: 15px;
      margin-top: 10px;
      color: #7c2ec0;
  }
  </style>
  